import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AutoMlService } from '../service/auto-ml.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements Permissions  {

  constructor(
    private _router: Router,
    private autoMlService:AutoMlService
    ) { }

    
  query(permissionDesc: PermissionDescriptor): any {
  }
    
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (this.autoMlService.getCookie('token')){
        return true;
      }else{
    
        this._router.navigateByUrl('login');
        return false;
      }
  }
  
}
